/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/transfer'
export default icon
